import { render, staticRenderFns } from "./FormAssetModule.vue?vue&type=template&id=f259bfba&scoped=true&lang=pug"
import script from "./FormAssetModule.vue?vue&type=script&lang=js"
export * from "./FormAssetModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f259bfba",
  null
  
)

export default component.exports